// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d_Ir","comment":"styles_comment__1T8hy"};